import { Capacitor } from '@capacitor/core';

export function ouvrirItineraire(latitude: number, longitude: number, adresse?: string): void {
  const destination = `${latitude},${longitude}`;
  if (Capacitor.getPlatform() === 'ios') {
    window.open(`maps://?q=${destination}`, '_system');
  } else {
    window.open(`geo:0,0?q=${destination}(${encodeURI(adresse ?? '')})`, '_system');
  }
}
